import { collection, doc, getDoc, getDocs, addDoc, updateDoc, deleteDoc, query, orderBy, Timestamp } from 'firebase/firestore';
import { db } from '../firebase';

export interface BlogPost {
  id: string;
  title: string;
  imageUrl?: string;
  linkUrl: string; // Wix blog URL
  order?: number;
  isActive: boolean;
  createdAt: Timestamp;
  updatedAt: Timestamp;
}

const COLLECTION_NAME = 'blog_posts';

export async function getBlogPosts(): Promise<BlogPost[]> {
  const q = query(collection(db, COLLECTION_NAME), orderBy('order', 'asc'));
  const snap = await getDocs(q);
  return snap.docs.map(d => ({ id: d.id, ...(d.data() as Omit<BlogPost, 'id'>) }));
}

export async function getActiveBlogPosts(): Promise<BlogPost[]> {
  const posts = await getBlogPosts();
  return posts.filter(p => p.isActive !== false);
}

export async function getBlogPost(id: string): Promise<BlogPost | null> {
  const ref = doc(db, COLLECTION_NAME, id);
  const snap = await getDoc(ref);
  if (!snap.exists()) return null;
  return { id: snap.id, ...(snap.data() as Omit<BlogPost, 'id'>) };
}

export async function createBlogPost(data: Omit<BlogPost, 'id' | 'createdAt' | 'updatedAt'>): Promise<string> {
  const now = Timestamp.now();
  const ref = await addDoc(collection(db, COLLECTION_NAME), { ...data, createdAt: now, updatedAt: now });
  return ref.id;
}

export async function updateBlogPost(id: string, data: Partial<Omit<BlogPost, 'id' | 'createdAt' | 'updatedAt'>>): Promise<void> {
  const ref = doc(db, COLLECTION_NAME, id);
  await updateDoc(ref, { ...data, updatedAt: Timestamp.now() });
}

export async function deleteBlogPost(id: string): Promise<void> {
  const ref = doc(db, COLLECTION_NAME, id);
  await deleteDoc(ref);
}
